export default __webpack_public_path__ + "locales/bg/DowngradePlanDialog.json?hash=2b553656fc25ce83508d97cc07f7b840";